import React, { useEffect, useState } from "react";
import { BarGraph, CommonHeader, Loader } from '../../../components/commons';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import moment from 'moment';
import {
    getInvoicingExpensesInsightsAction,
    getInvoicingRevenueInsightsAction,
    resetInsightsError,
    resetInsightsSuccess,
    resetInvoicingExpensesInsightsData,
    resetInvoicingRevenueInsightsData
} from '../../../redux/insights';

import { InvoicingInsightsPayload } from "../../../commonTypes/insightsTypes";
import { InvoicingInsightsType } from "../../../redux/insights/insightTypes";
import { InsightCard } from '../../../components/Insights';


type AppProps = {
    history?: any;
    date?: any;
    token: string | null;
    fetching: boolean;
    success: number | null;
    error: string | null;
    statusCode: number | null;
    invoicingRevenueInsightsData: InvoicingInsightsType[] | [];
    invoicingExpensesInsightsData: InvoicingInsightsType[] | [];
    dispatchGetInvoicingExpensesInsightsAction: (data: InvoicingInsightsPayload) => void;
    dispatchGetInvoicingRevenueInsightsAction: (data: InvoicingInsightsPayload) => void;
    dispatchResetInsightsErrorAction: () => void;
    dispatchResetInsightsSuccessAction: () => void;
    dispatchResetInvoicingRevenuInsightsData: () => void;
    dispatchResetInvoicingExpensesInsightsData: () => void;
}

const InvoiceDetail = ({
    history,
    date,
    token,
    fetching,
    success,
    error,
    statusCode,
    invoicingRevenueInsightsData,
    invoicingExpensesInsightsData,
    dispatchGetInvoicingExpensesInsightsAction,
    dispatchGetInvoicingRevenueInsightsAction,
    dispatchResetInsightsErrorAction,
    dispatchResetInsightsSuccessAction,
    dispatchResetInvoicingRevenuInsightsData,
    dispatchResetInvoicingExpensesInsightsData
}: AppProps) => {

    const client_code = history && history.location && history.location.state && history.location.state.client_code ? history.location.state.client_code : 0;

    const company_name = history && history.location && history.location.state && history.location.state.company_name ? history.location.state.company_name : '';

    const [revenueStartDate, setRevenueStartDate] = useState<string>(moment().subtract(365, 'd').format('DD-MM-YYYY'));
    const [revenueEndDate, setRevenueEndDate] = useState<string>(moment().format('DD-MM-YYYY'));
    const [expensesStartDate, setExpensesStartDate] = useState<string>(moment().subtract(365, 'd').format('DD-MM-YYYY'));
    const [expensesEndDate, setExpensesEndDate] = useState<string>(moment().format('DD-MM-YYYY'));
    const [oneMonthExpensesValue, setOneMonthExpensesValue] = useState(false);
    const [threeMonthExpensesValue, setThreeMonthExpensesValue] = useState(false);
    const [sixMonthExpensesValue, setSixMonthExpensesValue] = useState(false);
    const [oneYearExpensesValue, setOneYearExpensesValue] = useState(true);
    const [oneMonthRevenueValue, setOneMonthRevenueValue] = useState(false);
    const [threeMonthRevenueValue, setThreeMonthRevenueValue] = useState(false);
    const [sixMonthRevenueValue, setSixMonthRevenueValue] = useState(false);
    const [oneYearRevenueValue, setOneYearRevenueValue] = useState(true);
    const [twoYearsExpensesValue, setTwoYearsExpensesValue] = useState(false);
    const [twoYearsRevenueValue, setTwoYearsRevenueValue] = useState(false);
    const [threeYearsExpensesValue, setThreeYearsExpensesValue] = useState(false);
    const [threeYearsRevenueValue, setThreeYearsRevenuValue] = useState(false);
    const [fourYearsExpensesValue, setFourYearsExpensesValue] = useState(false);
    const [fourYearsRevenueValue, setFourYearsRevenueValue] = useState(false);

    useEffect(() => {
        dispatchResetInvoicingExpensesInsightsData();
        dispatchResetInvoicingRevenuInsightsData();
        if (token) {
            let finalRevenueData = {
                token,
                client_code: client_code,
                start_date: revenueStartDate,
                end_date: revenueEndDate,
            }

            let finalExpensesData = {
                token,
                client_code: client_code,
                start_date: expensesStartDate,
                end_date: expensesEndDate,
            }

            dispatchGetInvoicingRevenueInsightsAction(finalRevenueData);
            dispatchGetInvoicingExpensesInsightsAction(finalExpensesData);
        }
        dispatchResetInsightsErrorAction();
        dispatchResetInsightsSuccessAction();
    }, []);


    const revenueGraphData = invoicingRevenueInsightsData?.map((item: any) => {
        return item.invoice_value
    })

    const expensesGraphData = invoicingExpensesInsightsData?.map((item: any) => {
        return item.invoice_value
    });


    const handleGetSelectedRangeData = (val: number, type: string) => {
        if (type === 'expenses') {
            setExpensesStartDate(moment().subtract(val, 'd').format('DD-MM-YYYY'));
            setExpensesEndDate(moment().format('DD-MM-YYYY'));
            if (val === 30) {
                setOneMonthExpensesValue(true);
                setThreeMonthExpensesValue(false);
                setSixMonthExpensesValue(false);
                setOneYearExpensesValue(false)
            } else if (val === 90) {
                setOneMonthExpensesValue(false);
                setThreeMonthExpensesValue(true);
                setSixMonthExpensesValue(false);
                setOneYearExpensesValue(false);
            } else if (val === 180) {
                setOneMonthExpensesValue(false);
                setThreeMonthExpensesValue(false);
                setSixMonthExpensesValue(true);
                setOneYearExpensesValue(false);
            } else if (val === 365) {
                setOneMonthExpensesValue(false);
                setThreeMonthExpensesValue(false);
                setSixMonthExpensesValue(false);
                setOneYearExpensesValue(true);
                setTwoYearsExpensesValue(false);
                setThreeYearsExpensesValue(false);
                setFourYearsExpensesValue(false);
            } else if (val === 730) {
                setOneMonthExpensesValue(false);
                setThreeMonthExpensesValue(false);
                setSixMonthExpensesValue(false);
                setOneYearExpensesValue(false);
                setTwoYearsExpensesValue(true);
                setThreeYearsExpensesValue(false);
                setFourYearsExpensesValue(false);
            } else if (val === 1095) {
                setOneMonthExpensesValue(false);
                setThreeMonthExpensesValue(false);
                setSixMonthExpensesValue(false);
                setOneYearExpensesValue(false);
                setTwoYearsExpensesValue(false);
                setThreeYearsExpensesValue(true);
                setFourYearsExpensesValue(false);
            } else if (val === 1460) {
                setOneMonthExpensesValue(false);
                setThreeMonthExpensesValue(false);
                setSixMonthExpensesValue(false);
                setOneYearExpensesValue(false);
                setTwoYearsExpensesValue(false);
                setThreeYearsExpensesValue(false);
                setFourYearsExpensesValue(true);
            }

            if (token) {
                let finalExpensesData = {
                    token,
                    client_code: client_code,
                    start_date: moment().subtract(val, 'd').format('DD-MM-YYYY'),
                    end_date: moment().format('DD-MM-YYYY'),
                }

                dispatchGetInvoicingExpensesInsightsAction(finalExpensesData);
            }

        } else {
            setRevenueStartDate(moment().subtract(val, 'd').format('DD-MM-YYYY'));
            setRevenueEndDate(moment().format('DD-MM-YYYY'));
            if (val === 30) {
                setOneMonthRevenueValue(true);
                setThreeMonthRevenueValue(false);
                setSixMonthRevenueValue(false);
                setOneYearRevenueValue(false);
                setTwoYearsRevenueValue(false);
                setThreeYearsRevenuValue(false);
                setFourYearsRevenueValue(false);
            } else if (val === 90) {
                setOneMonthRevenueValue(false);
                setThreeMonthRevenueValue(true);
                setSixMonthRevenueValue(false);
                setOneYearRevenueValue(false);
                setTwoYearsRevenueValue(false);
                setThreeYearsRevenuValue(false);
                setFourYearsRevenueValue(false);
            } else if (val === 180) {
                setOneMonthRevenueValue(false);
                setThreeMonthRevenueValue(false);
                setSixMonthRevenueValue(true);
                setOneYearRevenueValue(false);
                setTwoYearsRevenueValue(false);
                setThreeYearsRevenuValue(false);
                setFourYearsRevenueValue(false);
            } else if (val === 365) {
                setOneMonthRevenueValue(false);
                setThreeMonthRevenueValue(false);
                setSixMonthRevenueValue(false);
                setOneYearRevenueValue(true);
                setTwoYearsRevenueValue(false);
                setThreeYearsRevenuValue(false);
                setFourYearsRevenueValue(false);
            } else if (val === 730) {
                setOneMonthRevenueValue(false);
                setThreeMonthRevenueValue(false);
                setSixMonthRevenueValue(false);
                setOneYearRevenueValue(false);
                setTwoYearsRevenueValue(true);
                setThreeYearsRevenuValue(false);
                setFourYearsRevenueValue(false);
            } else if (val === 1095) {
                setOneMonthRevenueValue(false);
                setThreeMonthRevenueValue(false);
                setSixMonthRevenueValue(false);
                setOneYearRevenueValue(false);
                setTwoYearsRevenueValue(false);
                setThreeYearsRevenuValue(true);
                setFourYearsRevenueValue(false);
            } else if (val === 1460) {
                setOneMonthRevenueValue(false);
                setThreeMonthRevenueValue(false);
                setSixMonthRevenueValue(false);
                setOneYearRevenueValue(false);
                setTwoYearsRevenueValue(false);
                setThreeYearsRevenuValue(false);
                setFourYearsRevenueValue(true);
            }

            if (token) {
                let finalRevenueData = {
                    token,
                    client_code: client_code,
                    start_date: moment().subtract(val, 'd').format('DD-MM-YYYY'),
                    end_date: moment().format('DD-MM-YYYY'),
                }
                dispatchGetInvoicingRevenueInsightsAction(finalRevenueData);
            }
        }

    }

    const handleSelectDateRange = (val: number, type: string) => {
        switch (val) {
            case 1:
                return handleGetSelectedRangeData(30, type);
            case 3:
                return handleGetSelectedRangeData(90, type);
            case 6:
                return handleGetSelectedRangeData(180, type);
            case 12:
                return handleGetSelectedRangeData(365, type);
            case 24:
                return handleGetSelectedRangeData(730, type);
            case 36:
                return handleGetSelectedRangeData(1095, type);
            case 48:
                return handleGetSelectedRangeData(1460, type);
            default:
                return handleGetSelectedRangeData(30, type);
        }
    }

    return (
        <div className="insights-dashboard">
            <CommonHeader
                title="Invoice Insights"
                client_code={client_code}
                company_name={company_name}
            />

            <div className="row mt-4">
                <div className="col-md-12 mt-4 ">
                    {/* {component} */}
                    <div className="mb-4">
                        <InsightCard
                            header='Expense Insights'
                            subHeader={`Data Range: ${ expensesStartDate } to ${ expensesEndDate }`}
                            showDetail={false}
                            legendName='Expenses'
                            seriesData={expensesGraphData}
                            xAxisData={
                                invoicingExpensesInsightsData?.map((item: any) => {
                                    return moment(item.date).format('DD-MM-YYYY')
                                })
                            }
                            height='500px'
                            showFilter
                            handleSelectDateRange={handleSelectDateRange}
                            xAxisName="Invoice Date"
                            yAxisName="Invoice Value"
                            oneMonthValue={oneMonthExpensesValue}
                            threeMonthValue={threeMonthExpensesValue}
                            sixMonthValue={sixMonthExpensesValue}
                            oneYearValue={oneYearExpensesValue}
                            twoYearsValue={twoYearsExpensesValue}
                            threeYearsValue={threeYearsExpensesValue}
                            fourYearsValue={fourYearsExpensesValue}
                            cardType="expenses"
                            barColor={['#fac858']}
                        />
                    </div>
                    <InsightCard
                        header='Receipt Insights'
                        subHeader={`Data Range: ${ revenueStartDate } to ${ revenueEndDate }`}
                        showDetail={false}
                        legendName='Sales/Receipts'
                        seriesData={revenueGraphData}
                        xAxisData={
                            invoicingRevenueInsightsData?.map((item: any) => {
                                return moment(item.date).format('DD-MM-YYYY')
                            })
                        }
                        barColor={['#91cc75']}
                        height='500px'
                        showFilter={true}
                        xAxisName="Invoice Date"
                        yAxisName="Invoice Value"
                        handleSelectDateRange={handleSelectDateRange}
                        oneMonthValue={oneMonthRevenueValue}
                        threeMonthValue={threeMonthRevenueValue}
                        sixMonthValue={sixMonthRevenueValue}
                        oneYearValue={oneYearRevenueValue}
                        twoYearsValue={twoYearsRevenueValue}
                        threeYearsValue={threeYearsRevenueValue}
                        fourYearsValue={fourYearsRevenueValue}
                        cardType="revenue"
                    />
                </div>
            </div>
            {fetching && <Loader />}
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.insights.fetching,
    success: state.insights.success,
    error: state.insights.error,
    statusCode: state.insights.statusCode,
    invoicingRevenueInsightsData: state.insights.invoicingRevenueInsightsData,
    invoicingExpensesInsightsData: state.insights.invoicingExpensesInsightsData
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetInvoicingExpensesInsightsAction: (data: InvoicingInsightsPayload) =>
        dispatch(getInvoicingExpensesInsightsAction(data)),
    dispatchGetInvoicingRevenueInsightsAction: (data: InvoicingInsightsPayload) =>
        dispatch(getInvoicingRevenueInsightsAction(data)),
    dispatchResetInsightsErrorAction: () => dispatch(resetInsightsError()),
    dispatchResetInsightsSuccessAction: () => dispatch(resetInsightsSuccess()),
    dispatchResetInvoicingRevenuInsightsData: () => dispatch(resetInvoicingRevenueInsightsData()),
    dispatchResetInvoicingExpensesInsightsData: () => dispatch(resetInvoicingExpensesInsightsData())
})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetail);

